<template>
  <div id="howto" class="howto">
    <Header />

    <div id="header-navi" class="header-navi">
      <h2 class="header-navi__ttl">HOW TO USE</h2>
    </div>

    <section class="howto__intro">
      <p class="howto__intro__text">カスタムアプリをご利用頂き、ありがとうございます。ご利用方法や、阪急うめだ本店1Fに設置しております「スマートミラー」との連携は、このページからご確認ください。</p>
    </section>
    <section class="howto__outline">
      <h2 class="howto__headline">カスタムアプリの使い方</h2>
      <section class="howto__outline__para">
        <h3 class="howto__heading">1. Home画面からブランド・商品を選択</h3>
        <p class="howto__outline__para__text">Home画面からカスタムを行いたいブランド選択後、カスタムを行いたいアイテムを選択してください。アイテムの詳細情報が記載された画面へリンクしますので、画面下部の「この商品をカスタマイズ」をクリックすると商品のカスタマイズが開始します。</p>
      </section>
      <section class="howto__outline__para">
        <h3 class="howto__heading">2. アイテムをカスタム画面で編集</h3>
        <p class="howto__outline__para__text">この画面から選択したアイテムをカスタムすることができます。画面下部のカスタムメニューから選択することができます。カスタムメニューはアイテムによって異なります。</p>
        <h4 class="howto__subtitle">例1: 色を変更</h4>
        <p class="howto__outline__para__text">カスタムメニューで選択された色に切り替わります。</p>
        <div class="howto__outline__para__flex">
          <figure class="howto__outline__para__img">
            <img src="@/assets/images/howto/howto-explain01.png" alt="example" />
            <figcaption class="howto__outline__para__img__caption">カラー選択画面（例）</figcaption>
          </figure>
        </div>
        <h4 class="howto__subtitle">例2: ワッペンを貼る</h4>
        <p class="howto__outline__para__text">貼りたいワッペンをカスタムメニューで選択すると、アイテム画像上に選択されたワッペンが表示されます。ワッペンはドラッグ&amp;ドロップでお好きな位置へ動かすことができます（アイテムによっては動かせないワッペンもあります）。
          <br />ワッペンを削除するときはゴミ箱アイコンをクリックしてください。回転アイコンを押したまま指を動かすことによって、ワッペンを回転させることができます。</p>
        <div class="howto__outline__para__flex">
          <figure class="howto__outline__para__img">
            <img src="@/assets/images/howto/howto-explain02.png" alt="example" />
            <figcaption class="howto__outline__para__img__caption">ワッペン選択画面（例）</figcaption>
          </figure>
          <figure class="howto__outline__para__img">
            <img src="@/assets/images/howto/howto-explain03.png" alt="example" />
            <figcaption class="howto__outline__para__img__caption">ワッペンの選択時</figcaption>
          </figure>
        </div>
        <h4 class="howto__subtitle">例3: 文字を入れる</h4>
        <p class="howto__outline__para__text">カスタムメニューから刺繍・刻印等の文字メニューを選択すると、文字入力のウィンドウが開きます。ここから文字を入力すると、アイテムへ文字を反映させることができます。</p>
        <div class="howto__outline__para__flex">
          <figure class="howto__outline__para__img">
            <img src="@/assets/images/howto/howto-explain04.png" alt="example" />
            <figcaption class="howto__outline__para__img__caption">文字の入力時</figcaption>
          </figure>
          <figure class="howto__outline__para__img">
            <img src="@/assets/images/howto/howto-explain05.png" alt="example" />
            <figcaption class="howto__outline__para__img__caption">文字（刺繍など）が表示</figcaption>
          </figure>
        </div>
      </section>
      <section class="howto__outline__para">
        <h3 class="howto__heading">3. カスタムアイテムの確認・購入</h3>
        <p class="howto__outline__para__text">カスタムを完了させ、プレビュー画面へ進むと内容を確認することができます。
          <br />プレビュー画面下部の「この商品を購入する」をクリックすると、阪急百貨店公式通販サイト（Hankyu E-STORES）へリンクし、カスタムしたアイテムを購入することができます。</p>
        <div class="howto__outline__para__flex">
          <figure class="howto__outline__para__img">
            <img src="@/assets/images/howto/howto-explain06.png" alt="example" />
            <figcaption class="howto__outline__para__img__caption">カスタム完了時</figcaption>
          </figure>
          <figure class="howto__outline__para__img">
            <img src="@/assets/images/howto/howto-explain07.png" alt="example" />
            <figcaption class="howto__outline__para__img__caption">カスタムアイテム確認画面</figcaption>
          </figure>
        </div>
      </section>
      <section class="howto__outline__para">
        <h3 class="howto__heading">4. カスタムアイテムの保存・再編集</h3>
        <p class="howto__outline__para__text">プレビュー画面へ進んだアイテムのカスタム内容は、お客様のスマートフォンへ自動で保存されます。保存されたアイテム一覧は、マイカスタム画面に表示されます。
          <br />アイテムを再カスタムしたい場合は、マイカスタム画面から該当アイテムを選択してください。不要になったカスタムアイテムは、マイカスタム画面の右上にある「Edit」ボタンから削除することもできます。</p>
      </section>
    </section>
    <section class="howto__outline">
      <h2 class="howto__headline">スマホとスマートミラーの連携方法</h2>
      <p class="howto__outline__para__text">お客様のスマートフォンと阪急うめだ本店1Fに設置されているスマートミラーを連携させることで、当アプリでカスタムしたアイテムを鏡に投影させ、お客様ご自身の姿と合わせて確認することができます。</p>
      <div class="howto__outline__para__flex">
        <figure class="howto__outline__para__img--fullwidth">
          <img src="@/assets/images/howto/howto-explain08.png" alt="example" />
        </figure>
      </div>
      <section class="howto__outline__para">
        <h3 class="howto__heading">5. カスタム内容をスマートミラーへ引き継ぐ</h3>
        <p class="howto__outline__para__text">スマートフォンで作成したカスタム内容をスマートミラーへ引き継ぐ場合は、「カスタム画面」もしくは「プレビュー画面」で表示されるQRコードをスマートミラーのカメラにかざしてください。
          スマートフォンに表示されたQRコードをスマートミラーが読み込んだらカスタムデータの連携は完了です。<br /></p>
      </section>
      <section class="howto__outline__para">
        <h3 class="howto__heading">6. スマートミラーからカスタム内容を受け取る</h3>
        <p class="howto__outline__para__text">スマートミラー上で行ったカスタム内容や、再編集したカスタム内容をお客様のスマートフォンへ移行・保存させることも可能です。その場合は、スマートミラーで表示されるQRコードをスマートフォンで読み取ってください。
          <br />なお、一度スマートフォンで読み取ったQRコードを、別のスマートフォンから再度読み込むことはできませんので、ご注意ください。</p>
      </section>
      <section class="howto__outline__para">
        <h3 class="howto__heading">7. アイテムをスマートミラーに投影する</h3>
        <p class="howto__outline__para__text">スマートフォンからスマートミラーへ引き継いだカスタムアイテム（もしくは、スマートミラー上で作成したカスタムアイテム）はスマートミラーへ投影し、お客様ご自身の姿と合わせて確認することができます。</p>
      </section>
    </section>

    <Footer />
  </div>
</template>

<script>
import Header from '@/components/Header'
import Footer from '@/components/Footer'

export default {
  components: {
    Header,
    Footer
  }
}
</script>

<style lang="scss" scoped>
.header-navi {
  @include customTitle;
}

.howto {
  &__intro {
    padding: 20px 0 30px;
    &__text {
      padding: 0 15px;
      font-size: 15px;
      font-weight: bold;
      line-height: 1.5;
    }
  }
  &__outline {
    padding: 0 0 20px 0;
    &__para {
      padding: 0 0 20px 0;
      &__flex {
        padding: 0 15px 30px;
        display: flex;
        justify-content: center;
        align-items: flex-start;
        flex-wrap: wrap;
      }
      &__img {
        width: calc(50% - 10px);
        &:nth-child(2n) {
          margin-left: 10px;
        }
        &__caption {
          font-size: 13px;
          font-weight: bold;
          margin: 5px 0 0 0;
        }
        &--fullwidth {
          width: 100%;
        }
      }
      &__text {
        padding: 15px 15px 20px 15px;
        line-height: 1.5;
        font-size: 15px;
      }
    }
  }
  &__headline {
    font-size: 16px;
    line-height: 1.5;
    padding: 15px;
    color: $base-white;
    background-color: $dark-gray;
  }
  &__heading {
    font-size: 16px;
    line-height: 1.5;
    font-weight: bold;
    padding: 20px 15px 10px;
    border-bottom: 1px solid $gray;
  }
  &__subtitle {
    font-size: 15px;
    font-weight: bold;
    padding: 20px 15px 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Howto.vue